// extracted by mini-css-extract-plugin
module.exports = {"list":"IEJ1U","link":"XrRhM","tip":"F1yZL"};